import { ABEventList, ABEventListFilter, ABLandingEventCard } from '../ab/event';
import { abGetDefaultCity, makeCitySegmented } from '../ab/widgets-home';
import { CEventHomeListView, cEventsHomeListViewActiveByCity, cEventsHomeListViewActiveByEventTag, cEventsHomeListViewFeaturedByCountry, cEventsHomeListViewOnline, cEventsHomeListViewOnlineByEventTag } from '../mdl/c-event-home';
import { c_event_tags, CEventTag, CEventTagId } from '../mdl/c-event-tag';
import { FPageCitySelectBlock, FPageEventsBlock, FPageFeaturedBlock } from '../mdl/f-page-block';
import { getCountry } from '../me/me';
import { UIButton } from '../ui/component/button';
import { UICarousel } from '../ui/component/carousel';
import { getDataValue, registerDataListener, registerField, setDataValue } from '../ui/component/field-tag';
import { $el } from '../ui/elements';
import { UIClassesSpec } from '../ui/types';
import { $on } from '../y/events';
import { $i18n } from '../y/i18n';
import { $location, YLocation } from '../y/location';
import { $id, YId } from '../y/types';
import { blkRegister } from './registry';

function makeLandingCard(e: CEventHomeListView) {
    return new ABLandingEventCard(e, 'event');
}

blkRegister<FPageFeaturedBlock>('featured', (_b, section, _p, _id, _flags) => {
    const content = $el.DIV('blk-featured b b-content');
    let all_events: CEventHomeListView[] = [];

    const toCity = (city_id: YId) => {
        const events = all_events.filter(e => e.city_id == city_id);
        const count = window.ab_stats.active_sessions_city[city_id];
        registerField(section, 'city.events', count + '');
        const carousel = new UICarousel(events.map(makeLandingCard), { auto_slide: true });
        content.ui_empty(carousel);
    };

    cEventsHomeListViewFeaturedByCountry(getCountry()).then(events => {
        all_events = events;
        toCity(getDataValue(content, 'city') ?? abGetDefaultCity().id);
        registerDataListener(content, 'city', toCity);
    });

    return content;
});

blkRegister<FPageEventsBlock>('events', (b, _section, promises: Promise<any>[], id: string) => {
    const block = $el.DIV('tl-events-block', [
        b.show_header && $el.DIV('l-h r-header w-block', [
            $el.fromEditedHtml(b.header, 'r-text p-f-events-title'),
            b.show_button && new UIButton({
                title: $i18n.tl.b_see_all, classes: 'ui-tint-reverse', on_click: () => {
                    if(see_all_location)
                        $location.navigate(see_all_location);
                }
            })
        ])
    ]);

    let classes: UIClassesSpec = ['w-block', b.color_scheme && b.color_scheme != 'inherit' && 'c-' + b.color_scheme];
    let filter: ABEventListFilter | undefined;
    let tag: CEventTag | undefined;

    let see_all_location: YLocation | undefined;

    let event_query: Promise<CEventHomeListView[]>;

    if(b.query == 'streams') {
        event_query = cEventsHomeListViewOnline(getCountry());
        filter = 'videos';
        see_all_location = { path: ['search'], params: { video: true, tag_id: $id.maybeObjectIdToId(b.tag) as CEventTagId } };
    } else if(b.query == 'tag' || b.query == 'video_tag') {
        if(!b.tag) return undefined;
        tag = c_event_tags.maybe($id.objectIdToId(b.tag));
        if(!tag) return undefined;
        if(b.query == 'video_tag') {
            event_query = cEventsHomeListViewOnlineByEventTag(getCountry(), $id.objectIdToId(b.tag) as CEventTagId);
            filter = 'videos';
            see_all_location = { path: ['search'], params: { video: true, tag_id: $id.maybeObjectIdToId(b.tag) as CEventTagId } };
        } else {
            event_query = cEventsHomeListViewActiveByEventTag($id.objectIdToId(b.tag) as CEventTagId);
            filter = tag.flags.show_future ? 'future' : 'active';
            see_all_location = { path: ['search'], params: { tag_id: $id.maybeObjectIdToId(b.tag) as CEventTagId } };
        }
    } else {
        event_query = cEventsHomeListViewActiveByCity();
        filter = 'active';
    }

    promises.push(event_query!.then(events => {
        block.ui_add(new ABEventList('events', b.display, b.shape, events, { classes, filter, limit: b.limit, no_progressive: true, sort: b.sort, randomize: b.randomize, tag, id }));
    }));

    return block;
});

blkRegister<FPageCitySelectBlock>('cityselect', (_b, section) => {
    const segmented = makeCitySegmented({ kind: 'k-new' });
    $on(segmented, 'value', v => {
        setDataValue(section, 'city', v);
    });
    segmented.value = abGetDefaultCity().id;

    return $el.DIV('blk-cityselect b b-content', segmented);
});
